var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDomainExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 840.629,
    height: 574.437,
    viewBox: "0 0 840.629 574.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c6dc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-hybrid-cloud-3526751",
    transform: "translate(-15.985 -88.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M212.153,662.55c132.958,0,177.02-70.472,223.669-145.083l1-1.6-23.767-14.862-1,1.6c-46.076,73.7-82.475,131.922-199.9,131.922a168.111,168.111,0,1,1-.026-336.222h.023c97.6.028,153.454,85.473,212.591,175.935,40.439,61.858,81.792,125.107,138.315,160.287H394.28v28.031h266.2c108.319,0,196.135-87.816,196.135-196.142S768.8,270.275,660.472,270.275a170.927,170.927,0,0,0-22.7,1.543c-1.847.011-3.667.063-5.477.137a196.207,196.207,0,0,0-391.662.478,187.321,187.321,0,0,0-28.478-2.158H212.1c-108.3,0-196.116,87.812-196.116,196.138S103.8,662.555,212.127,662.555Zm224.328-546.4A168.4,168.4,0,0,1,604.45,275.708c-65.663,15.577-105.373,75.737-143.081,141.714l24.336,13.911c41.117-71.944,81.012-131.495,153.044-131.495a14.151,14.151,0,0,0,1.943-.135,143.312,143.312,0,0,1,19.773-1.4,168.111,168.111,0,0,1,0,336.222h-.175c-90.783,0-145.423-74.325-200.308-157.666,3.52-6.169,6.9-12.159,9.948-17.581L445.5,445.528l-2.793,4.956c-48.018-73.328-98.237-146.744-174.32-171.466A168.384,168.384,0,0,1,436.481,116.153Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M342.016,470.266H510.2a14.016,14.016,0,0,0,14.016-14.016V344.125A14.016,14.016,0,0,0,510.2,330.11H496.188V302.078a70.078,70.078,0,1,0-140.157,0V330.11H342.016A14.016,14.016,0,0,0,328,344.125V456.251A14.016,14.016,0,0,0,342.016,470.266Zm42.047-168.188a42.047,42.047,0,1,1,84.094,0V330.11H384.063Zm-28.031,56.063H496.188v84.094H356.031Z",
    transform: "translate(234.622 108.19)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M182.141,232A126.141,126.141,0,1,0,308.282,358.141,126.141,126.141,0,0,0,182.141,232ZM85.049,372.157a97,97,0,0,1,0-28.031h27.439c-.272,4.625-.426,9.3-.426,14.016s.154,9.39.426,14.016Zm8.467,28.031h22.367a170.775,170.775,0,0,0,12.343,39.862,98.752,98.752,0,0,1-34.71-39.862Zm22.367-84.094H93.516a98.753,98.753,0,0,1,34.71-39.862,170.776,170.776,0,0,0-12.343,39.862Zm52.242,133.582c-9.687-8.96-18.536-26.563-23.6-49.488h23.6Zm0-77.519H140.574c-.307-4.555-.48-9.231-.48-14.016s.175-9.461.48-14.016h27.551Zm0-56.063h-23.6c5.063-22.924,13.912-40.528,23.6-49.488Zm102.64,0H248.4a170.777,170.777,0,0,0-12.343-39.862,98.752,98.752,0,0,1,34.71,39.862Zm-74.609-49.488c9.687,8.96,18.536,26.563,23.6,49.488h-23.6Zm0,183.069V400.188h23.6C214.692,423.112,205.843,440.716,196.157,449.675Zm27.551-77.519H196.157V344.125h27.551c.307,4.555.48,9.231.48,14.016S224.013,367.6,223.708,372.157Zm12.348,67.894A170.775,170.775,0,0,0,248.4,400.188h22.367A98.751,98.751,0,0,1,236.056,440.05Zm44.195-81.909a98.352,98.352,0,0,1-1.018,14.016H251.793c.272-4.625.426-9.3.426-14.016s-.154-9.391-.426-14.016h27.439A98.357,98.357,0,0,1,280.251,358.141Z",
    transform: "translate(30.09 108.19)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainExpert);
export default __webpack_public_path__ + "static/media/domainExpert.9c96149ec74cd9d0def90dc6ebfe40cb.svg";
export { ForwardRef as ReactComponent };